/**
 * Read an NDJSON body line by line as it arrives: each complete line goes to
 * `onLine` the moment its newline does, the last one when the body ends. A
 * line split across two chunks is joined first. Resolves when the body ends
 * or breaks (the shopper left, the network dropped): what came is kept.
 * Client-safe.
 */
export async function readNdjsonLines(
  body: ReadableStream<Uint8Array>,
  onLine: (line: string) => void,
): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  const flushLines = () => {
    let newline = buffer.indexOf('\n');
    while (newline !== -1) {
      const line = buffer.slice(0, newline);
      buffer = buffer.slice(newline + 1);
      if (line.trim()) onLine(line);
      newline = buffer.indexOf('\n');
    }
  };
  try {
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      flushLines();
    }
    buffer += `${decoder.decode()}\n`;
    flushLines();
  } catch {
    // The stream broke: keep what came.
  }
}
